var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconRunColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M19.404 20.833h-.416l-16.429 1.19a1.494 1.494 0 00-1.369 1.49c0 .832.655 1.487 1.488 1.487h16.726c1.131 0 2.084-.952 2.084-2.083a2.196 2.196 0 00-2.084-2.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M12.202 0c1.13 0 2.083.952 2.083 2.083 0 1.131-.952 2.084-2.083 2.084-1.131 0-2.083-.953-2.083-2.084C10.119.953 11.07 0 12.202 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A825",
    d: "M6.547 17.262H2.38c-.654 0-1.19-.536-1.19-1.19 0-.655.536-1.191 1.19-1.191h3.393l1.786-3.75a1.194 1.194 0 011.607-.536c.595.298 1.488 1.25 1.19 1.845L7.56 16.607c-.119.417-.536.655-1.012.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M4.464 10.714c-.179 0-.417-.06-.536-.178-.357-.298-.476-.893-.119-1.25l2.083-2.679c.06-.06.12-.178.238-.178L9.285 4.94a.83.83 0 01.655-.119l2.976.596c.357.06.595.297.655.654l.714 3.453h2.679c.476 0 .893.416.893.893a.916.916 0 01-.893.893H13.63c-.416 0-.773-.239-.833-.655l-.774-3.631-2.083-.417-2.798 1.19-1.964 2.56a.93.93 0 01-.714.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M20.833 22.024V11.905h-1.786l-2.381 10.119z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M21.904 13.095h-5.833v-1.19h4.881l1.071-4.881 1.191.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M22.023 11.905h-2.976l2.679-5.953h2.083zM2.538 22.027l16.444-1.191.086 1.187-16.444 1.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M2.678 23.81a.282.282 0 01-.298-.298c0-.179.12-.298.298-.298v-1.19c-.833 0-1.488.655-1.488 1.488S1.845 25 2.678 25v-1.19zm0 0h16.726V25H2.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M19.345 20.833v1.19c.476 0 .893.417.893.894a.916.916 0 01-.893.893V25c1.13 0 2.083-.952 2.083-2.083 0-1.131-.952-2.084-2.083-2.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M19.047 22.024h.595l-.238-1.191h-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M20.238 22.917a.916.916 0 01-.893.893.916.916 0 01-.893-.893c0-.477.417-.893.893-.893.476 0 .893.416.893.893z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA68C8",
    d: "M13.511 6.012a1.179 1.179 0 00-.654-.655L9.88 4.762c-.238-.06-.416 0-.654.119l-1.19.536.773 1.607 1.012-.476 2.083.416.298 1.31h1.786l-.477-2.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M10.714 21.429c-.12 0-.298 0-.417-.06-.595-.238-.952-.893-.714-1.548l1.488-4.047-2.917-2.738c-.476-.476.06-.893.536-1.37.476-.476 1.548-1.19 1.964-.714l2.679 3.69c.357.358.417.834.297 1.25l-1.785 4.763a1.222 1.222 0 01-1.131.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41A571",
    d: "M9.226 10.595a1.192 1.192 0 00-1.607.536l-1.31 2.738 2.143 1.429 1.964-2.977c.298-.535-.655-1.428-1.19-1.726z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA68C8",
    d: "M9.583 13.571c-.179 0-.357 0-.595-.06-1.131-.297-1.727-1.487-1.429-2.559l1.37-3.869c.297-1.13 1.487-1.726 2.559-1.428 1.13.297 1.726 1.488 1.428 2.56l-1.607 4.88c-.298.893-.833.476-1.726.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EC08F",
    d: "M7.678 10.595l-.119.357c-.238.834.06 1.727.714 2.203l2.5 2.321 1.965-1.666-1.19-1.667-3.87-1.548z"
  }))));
}

export default SvgCommonIconRunColor;